module.exports = __webpack_public_path__ + "static/media/accessory__flameSensor.6908ec75.jpg";